import { InjectionToken } from "@angular/core";
import { IStripeService } from "./i-stripe.service";

export const stripeServiceInjectionToken: InjectionToken<IStripeService> =
	new InjectionToken<IStripeService>("digital-signage.user-dashboard.dashboard-web.StripeService");
